module.exports = __webpack_public_path__ + "img/discount (1).87c61e73.svg";